"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = defaultLocalLogger;
/* eslint-disable no-console */
const __1 = require("..");
const getLocalLogArguments_1 = __importDefault(require("./getLocalLogArguments"));
function defaultLocalLogger(level, message, metadata) {
    if (level === __1.LogLevel.Debug) {
        return;
    }
    toConsoleFunction(level)(...(0, getLocalLogArguments_1.default)(message, metadata));
}
function toConsoleFunction(logLevel) {
    switch (logLevel) {
        case __1.LogLevel.Error:
            return console.error;
        case __1.LogLevel.Warn:
            return console.warn;
        case __1.LogLevel.Info:
            return console.info;
        case __1.LogLevel.Debug:
            return console.debug;
        default: {
            const neverLevel = logLevel;
            throw new Error(`Unknown log level: ${neverLevel}`);
        }
    }
}
//# sourceMappingURL=defaultLocalLogger.js.map